module.exports = {
  sanity: {
    projectId: process.env.SANITY_PROJECT_ID || '3lfywj5y',
    dataset: process.env.SANITY_DATASET || 'production',
  },
};
